module.exports = __webpack_public_path__ + "static/media/QC.656da757.svg";